<div  class="flex flex-col justify-center md:px-14 px-5 filter grayscale-0 opacity-60 md:h-0 h-24 md:fixed bottom-10 w-full items-center  md:items-start">  
    <p class="text-xxs">{{'txtPoweredby'| translate:language:ModuleNames.Shared}}</p>
    <img class="md:h-8 h-7 grayscale" src="assets/img/svg/logo.svg" alt="ZENITHR Logo" />
</div>